<planone-filter-button
  [markActiveFilters]="markAsActive"
  [screen]="screen"
  (filterButtonClicked)="onFilterButtonClicked()">
</planone-filter-button>
